<!-- Order Form Card -->
<div class="card mx-auto chatbot" style="max-width: 420px; height: auto; padding: 0.5rem; min-height: 100vh;" *ngIf="card">
  <div *ngIf="showSuccess" class="text-center mt-5 mb-5 p-4">
    <img [src]="pharmaLogo || 'assets/images/docquitycarelogo.svg'" alt="Docquity Care" style="width: 12rem; margin-bottom: 14rem;" />
    <div>
      <img src="assets/images/thumbs-up.svg" alt="Success" style="width: 80px; margin-bottom: 24px;" />
    </div>
    <h3 style="font-weight: bold; margin-bottom: 12px;">{{ 'CONGRATULATIONS' | translate }}</h3>
    <div style="color: #888; font-size: 16px;">
      {{ 'REGISTRATION_SUCCESS_MESSAGE' | translate }}
    </div>
  </div>
  <div *ngIf="!showSuccess">
    <div style="width: 24px; margin-left: 5%; margin-bottom: 1%;">
      <img src="assets/images/left-back.svg" alt="Back" style="width: 32px; height: 32px; cursor: pointer;" (click)="goToPreviousCard()" />
    </div>
    <div class="alert alert-info text-center rounded-4" style="margin-left: 5%; margin-right: 5%;" *ngIf="card?.pageName === 'order'">
        {{ pharmaTagline || ('CHATBOT_DEFAULT_TAGLINE' | translate) }}
    </div>
    <div class="card-body mb-3">
      <h4 class="card-title mb-3" style="font-size: 1.1rem; font-weight: bold;">{{ card.title | translate }}</h4>
      <p class="text-muted mb-4" *ngIf="card.description">{{ card.description | translate }}</p>
      <!-- Consent Card -->
      <form *ngIf="card.type === 'consent'" [formGroup]="consentForm" (ngSubmit)="onConsentSubmit()">
        <div class="terms-container mb-4">
          <div *ngFor="let term of terms; let i = index">
            <div class="mt-2" *ngIf="i <= 2">
              <div class="d-flex flex-row align-items-start mt-2 custom-control custom-checkbox">
                <input class="mr-2 custom-control-input" type="checkbox" id="checkbox_{{i}}" [checked]="true" [disabled]="true">
                <label class="custom-control-label" for="checkbox_{{i}}">
                  <span class="fnt-size12px text-rolling-stone-grey text-break" [innerHTML]=term></span>
                  <span class="fnt-size12px text-rolling-stone-grey" *ngIf="!showAllTerms && i === 2 && terms.length > 3">...</span>
                  <p class="text-success fnt-size12px cursor-pointer" *ngIf="!showAllTerms && i === 2 && terms.length > 3" (click)="showAllTerms = true">{{'READ_MORE' | translate}}</p>
                </label>
              </div>
            </div>
            <div *ngIf="i > 2 && showAllTerms">
              <div class="d-flex flex-row align-items-start mt-2 custom-control custom-checkbox">
                <input class="mr-2 custom-control-input" type="checkbox" id="checkbox_{{i}}" [checked]="true" [disabled]="true">
                <label class="custom-control-label" for="checkbox_{{i}}">
                  <span class="fnt-size12px text-rolling-stone-grey text-break" [innerHTML]=term></span>
                  <p class="text-success fnt-size12px cursor-pointer" *ngIf="showAllTerms && i + 1 === terms.length" (click)="showAllTerms = false">{{'READ_LESS' | translate}}</p>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="form-check mb-4 d-none">
          <input type="checkbox" class="form-check-input" id="termsAccepted" formControlName="termsAccepted">
          <label class="form-check-label" for="termsAccepted">{{ 'ACCEPT_TERMS' | translate }}</label>
        </div>
        <button type="submit" class="btn btn-block w-100"
          [ngStyle]="{
            'background': consentForm.valid ? '#232323' : '#D3D3D3',
            'color': '#fff',
            'border': 'none'
          }"
          [disabled]="consentForm.invalid">
          {{ card.submitText | translate }}
        </button>
      </form>
      <!-- Regular Form Card -->
      <form *ngIf="card.fields" [formGroup]="currentCardForm" (ngSubmit)="onCardSubmit(card)">
        <ng-container *ngIf="card.fields">
          <div class="form-group mb-3" *ngFor="let field of card.fields">
            <label>{{ getFieldLabelKey(field) | translate }} <span class="text-danger" *ngIf="field.isRequired">*</span></label>

            <!-- Caregiver Mobile Number: Custom Combined Field -->
            <ng-container *ngIf="field.key === 'caregiverMobile'; else notCaregiverMobile">
              <div class="d-flex align-items-center" style="gap: 8px;">
                <div style="position: relative; min-width: 110px; max-width: 110px;">
                  <img [src]="selectedCountryFlag" width="22" height="16"
                       style="position: absolute; left: 10px; top: 50%; transform: translateY(-50%); z-index: 2; pointer-events: none;" />
                  <select class="form-control"
                          style="padding-left: 38px; height: 40px; border-radius: 6px; -webkit-appearance: none; appearance: none; background-image: url('assets/images/dropdown-icon.svg'); background-repeat: no-repeat; background-position: right 8px center; padding-right: 24px;"
                          [formControlName]="'caregiverCountryCode'">
                    <option *ngFor="let country of countries" [value]="country.dialCode">
                      {{ country.dialCode }}
                    </option>
                  </select>
                </div>
                <input type="tel"
                       class="form-control"
                       [formControlName]="'caregiverMobile'"
                       [placeholder]="getFieldPlaceholderKey(field) | translate"
                       maxlength="15"
                       minlength="8"
                       (keyup)="userInput(card.pageName,field.key, $event)"
                       (input)="preventSpaces(card.pageName,field.key, $event)"
                       (keypress)="onlyNumbers($event)"
                       style="height: 40px; border-radius: 6px; flex: 1 1 auto;" />
              </div>
              <div *ngIf="isFieldInvalid(card.pageName, field.key)" class="text-danger fnt-size12px">
                {{ field.required | translate }}
              </div>
              <div *ngIf="isFieldInvalid(card.pageName, field.key) && field.patternError" class="text-danger fnt-size12px">
                {{ field.patternError | translate }}
              </div>
            </ng-container>

            <ng-template #notCaregiverMobile>
              <!-- Autocomplete for search type -->
              <ng-container *ngIf="field.type === 'search'; else defaultField">
                <p-dropdown
                  [styleClass]="'w-100 custom-dropdown'"
                  [panelStyle]="{ 'min-width': '350px' }"
                  [placeholder]="'SELECT_PROGRAM_OR_DRUG_NAME' | translate"
                  formControlName="program"
                  [options]="programList"
                  optionLabel="Program.Name"
                  (onChange)="onSelectProgram($event.value)">
                  <ng-template let-program pTemplate="item">
                    <div class="dropdown-program-item">
                      <div class="program-title">{{ program.Program.Name }}</div>
                      <div class="program-drugs">
                        <ng-container *ngFor="let drug of program.Program.Drugs; let isLast=last">
                          <p>
                            <span>{{ drug.GenericName }} ({{ drug.BrandName }})</span>
                          </p>
                        </ng-container>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="selectedItem" let-selectedProgram>
                    <div class="selected-program-template">
                      <div class="program-title">{{ selectedProgram.Program.Name }}</div>
                      <div class="program-drugs">
                        <ng-container *ngFor="let drug of selectedProgram.Program.Drugs; let isLast=last">
                          <p>
                            <span>{{ drug.GenericName }} ({{ drug.BrandName }})</span>
                          </p>
                        </ng-container>
                      </div>
                    </div>
                  </ng-template>
                </p-dropdown>
              </ng-container>
              <ng-template #defaultField>
                <input *ngIf="field.type === 'text' || field.type === 'tel'" 
                       [type]="field.type" 
                       class="form-control" 
                       [formControlName]="field.key"
                       [placeholder]="getFieldPlaceholderKey(field) | translate"
                       [maxlength]="field.maxLength"
                       (keypress)="field.key === 'firstName' || field.key === 'middleName' || field.key === 'lastName' || field.key === 'initials' ? noSpecialChars($event) : null"
                       (keyup)="(field.key === 'firstName' || field.key === 'middleName' || field.key === 'lastName' || field.key === 'address' || field.key === 'caregiverName' || field.key === 'idCardNumber' || field.key === 'initials') ? userInput(card.pageName,field.key, $event) : null" />
                <div *ngIf="field.type === 'date'" class="calendar-field w-100">
                  <p-calendar [showIcon]="true" 
                            [monthNavigator]="true" 
                            [yearNavigator]="true" 
                            yearRange="1922:2030" 
                            [inline]="false" 
                            panelStyleClass="bg-white border"
                            [maxDate]="field.key === 'dob' ? today : null"
                            [inputStyleClass]="'form-control fnt-size12px fnt_Medium'"
                            [formControlName]="field.key"
                            [placeholder]="getFieldPlaceholderKey(field) | translate"
                            dateFormat="dd M yy">
                  </p-calendar>
                </div>
                <textarea *ngIf="field.type === 'textarea'"
                          class="form-control"
                          [formControlName]="field.key"
                          [placeholder]="getFieldPlaceholderKey(field) | translate"
                          [maxlength]="field.maxLength"
                          (keyup)="(field.key === 'address') ? userInput(card.pageName,field.key, $event) : null"
                          rows="3"></textarea>
                <select *ngIf="field.type === 'select' || field.type === 'dropdown'" 
                        class="form-control select" 
                        [formControlName]="field.key">
                  <option value="" disabled selected hidden>{{ getFieldPlaceholderKey(field) | translate }}</option>
                  <option *ngFor="let option of field.options" [value]="option.value">{{option.label | translate}}</option>
                </select>
                <div *ngIf="field.type === 'file'" class="file-upload-container">
                  <label
                    class="d-block w-100"
                    style="border: 2px dashed #ccc; border-radius: 8px; padding: 20px; text-align: center; cursor: pointer; background: #fafbfc;"
                    for="fileInput"
                    >
                    <div style="display: flex; flex-direction: column; align-items: center;">
                      <img src="assets/images/upload-photo-icon.svg" width="40" height="40" alt="Upload" style="margin-bottom: 8px;" />
                      <span style="color: #0070f3; font-weight: 500;">{{ 'UPLOAD_ID_PHOTO' | translate }}</span>
                      <span style="color: #888; font-size: 12px;">{{ 'UPLOAD_ID_HINT' | translate }}</span>
                      <span *ngIf="idCardFileName" style="color: #333; font-size: 13px; margin-top: 8px;">{{ idCardFileName }}</span>
                    </div>
                    <input
                      type="file"
                      id="fileInput"
                      class="d-none"
                      #fileInput
                      (change)="onIdCardFileChange($event)"
                      accept="image/jpeg,image/png"
                      (click)="$event.stopPropagation()"
                    />
                  </label>
                  <div *ngIf="idCardFileError" class="text-danger fnt-size12px mt-1">
                    {{ idCardFileError }}
                  </div>
                  <div *ngIf="idCardImageSrc" class="mt-2">
                    <img [src]="idCardImageSrc" class="img-thumbnail" style="max-width: 200px;" />
                  </div>
                </div>
                <div *ngIf="isFieldInvalid(card.pageName, field.key)" class="text-danger fnt-size12px">
                  {{ field.required | translate }}
                </div>
                <div *ngIf="isFieldInvalid(card.pageName, field.key) && field.patternError" class="text-danger fnt-size12px">
                  {{ field.patternError | translate }}
                </div>
              </ng-template>
            </ng-template>
          </div>
        </ng-container>
        <button type="submit" class="btn btn-block w-100"
          [ngStyle]="{
            'background': currentCardForm?.valid ? '#232323' : '#D3D3D3',
            'color': '#fff',
            'border': 'none',
            'margin-top': card.pageName === 'order' ? '20rem' : '0'
          }"
          [disabled]="currentCardForm?.invalid">
          {{ card.submitText | translate }}
        </button>
      </form>
    </div>
  </div>
</div>
